import { StyleSheet, View, ViewProps } from 'react-native';

import { colors, spacing } from '../../theme';
import { HoverTextTooltip } from '../HoverTextTooltip';
import { HelpMarkIcon } from '../../assets';

export const WebCard = ({ style, children, helpText, ...viewProps }: WebCardProps) => {
	return (
		<View style={[styles.card, style]} {...viewProps}>
			{helpText && (
				<View style={styles.helpContainer}>
					<HoverTextTooltip style={styles.helpTooltip} content={helpText}>
						<HelpMarkIcon />
					</HoverTextTooltip>
				</View>
			)}

			{children}
		</View>
	);
};
export interface WebCardProps extends ViewProps {
	helpText?: string;
}

const styles = StyleSheet.create({
	card: {
		backgroundColor: colors.white,
		borderRadius: spacing(),
		padding: spacing(3),
		flex: 1,
	},
	helpContainer: {
		position: 'absolute',
		top: 0,
		right: 0,
		padding: spacing(1),
		zIndex: 9999,
	},
	helpTooltip: { width: 295 },
});
